import React from 'react'
import Image from 'next/image'
import { IMAGE_MEDIA_REGEX, VIDEO_MEDIA_ENDING, VIDEO_NO_SUPPORT } from '@constants/aboutUs'
import styles from './Partnerships.module.scss'

export const TopHeader: React.FC<{ capital: string; heading: string }> = ({ capital, heading }) => (
  <div className={styles.topHeader}>
    <span className={styles.capitalText}>{capital}</span>
    <span className={styles.heading}>{heading}</span>
  </div>
)

export const MediaContainer: React.FC<{ src: string; centeredMedia: boolean }> = ({ src, centeredMedia }) => {
  const isVideo = src.endsWith(VIDEO_MEDIA_ENDING)
  const isImage = IMAGE_MEDIA_REGEX.test(src)

  if (isVideo) {
    return (
      <video autoPlay loop muted playsInline className={styles.cardVideo}>
        <source src={src} type="video/mp4" />
        {VIDEO_NO_SUPPORT}
      </video>
    )
  }

  if (isImage) {
    return (
      <Image
        src={src}
        alt="Grid Image/GIF"
        loading="lazy"
        width={100}
        height={140}
        className={`${styles.cardImage} ${centeredMedia ? styles.extraPadding : ''}`}
      />
    )
  }

  return null
}
